/**
 * `assets/language/language.txt` の内容と同一の参照用コピー（ビルド時バンドル）。
 * HTTP での読み込みに失敗しても Map が空にならないようにする。
 * 参照ファイル本体は編集しない運用のため、ここは参照ファイルと同期させること。
 */
export const EMBEDDED_LANGUAGE_TXT = `病院 ↔ 施設
患者 ↔ 利用者
診療科 ↔ 介護施設
看護師 ↔ スタッフ
入院 ↔ 入居
退院 ↔ 退居
医療機関コード ↔ 介護事業所番号
病院名 ↔ 介護事業名
診療科名 ↔ 介護施設名
診療科コード ↔ 介護施設コード
患者名 ↔ 利用者名
患者ID ↔ 利用者ID
高リスク患者 ↔ 高リスク利用者
中リスク患者 ↔ 中リスク利用者
低リスク患者 ↔ 低リスク利用者
睡眠中患者 ↔ 睡眠中利用者
覚醒中患者 ↔ 覚醒中利用者
病院管理 ↔ 施設管理
病院検索 ↔ 施設検索
病院登録 ↔ 施設登録
病院更新 ↔ 施設更新
病院削除 ↔ 施設削除
患者管理 ↔ 利用者管理
患者マスタ検索 ↔ 利用者マスタ検索
患者マスタ登録 ↔ 利用者マスタ登録
患者マスタ編集 ↔ 利用者マスタ編集
病院管理者 ↔ 施設管理者`;
